import React from 'react';
import Link from 'next/link';

const BlogLink = ({ internal, external, children}) => {
  if (internal) {
    return (
      <Link href={internal} target="_blank" rel="noreferrer">

        { children }

      </Link>
    );
  }

  if (external) {
    return (
      <a href={external} target="_blank" rel="noreferrer">
        { children }
      </a>
    );
  }

  return <>{ children }</>;
};

export default BlogLink;
